"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormControlLabel2 = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _FormHelperText = _interopRequireDefault(require("../form-helper-text/FormHelperText"));

var _FormControlLabel3 = _interopRequireDefault(require("./FormControlLabel.styles"));

var _excluded = ["className", "helperText"];

function FormControlLabel(props) {
  var className = props.className,
      helperText = props.helperText,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _FormControlLabel3.default)();

  var helperTextComponent = function helperTextComponent() {
    var controlElementId = otherProps.control.props.id;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, otherProps.label, helperText && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
      style: {
        opacity: 1
      },
      id: "".concat(controlElementId, "-helper-text"),
      "data-testid": "helperTextId"
    }, helperText));
  };

  return /*#__PURE__*/_react.default.createElement(_FormControlLabel2.default, Object.assign({}, otherProps, {
    className: (0, _classnames.default)('pds-form-control-label', className),
    classes: classes,
    label: helperTextComponent(),
    htmlFor: otherProps === null || otherProps === void 0 ? void 0 : otherProps.control.props.id
  }));
}

FormControlLabel.propTypes = {
  /**
   * A CSS class to add to the root node of the component.
   */
  className: _propTypes.string,

  /**
   * A control element. For instance, it can be be a Radio or a Checkbox.
   */
  control: _propTypes.element.isRequired,

  /**
   * If true, the control will be disabled and the label will use disabled CSS styles.
   */
  disabled: _propTypes.bool,

  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes.node.isRequired,

  /**
   * To add a helper text in a control element.
   */
  helperText: _propTypes.string
};
var _default = FormControlLabel;
exports.default = _default;
